import type { RawAuthUser } from '@/store/authStore';
import { pickBool } from '@/shared/lib/pickField';

/**
 * Mirrors iOS `UserManager.getUser?.showReportCardMenu` with defensive parsing.
 */
export function readShowReportCardMenuFromRawUser(
  rawUser: RawAuthUser | null | undefined,
): boolean {
  if (!rawUser || typeof rawUser !== 'object') return false;

  const raw = rawUser as Record<string, unknown>;

  return pickBool(raw, 'showReportCardMenu', 'show_report_card_menu');
}
